import "./index.scss";
export default function SearchBox() {
  return (
    <div className="SearchBox position-relative mx-1">
      <label className="d-flex w-100 position-relative bg-white border border-secondary rounded-pill">
        <input type="text" placeholder="جستجو..." className='py-2 px-3 fs-6' />
        <i className="bi bi-search d-flex flex-center fs-5 cursor-pointer" />
      </label>
    </div>
  );
}
